class Image {
  constructor({
    /*: {
        id: string;
        height: number;
        imageType: string;
        md5: string;
        mimeType: string;
        size: number;
        timestamp: number;
        uri: string;
        url: string;
        userId: string;
        width: number;
      }*/

    id,
    height,
    imageType,
    md5,
    mimeType,
    size,
    timestamp,
    uri,
    url,
    userId,
    width
  }) {
    this.id = id;
    this.height = height;
    this.imageType = imageType;
    this.md5 = md5;
    this.mimeType = mimeType;
    this.size = size;
    this.timestamp = timestamp;
    this.uri = uri;
    this.url = url;
    this.userId = userId;
    this.width = width;
  }

}

module.exports = Image;